module.exports = __webpack_public_path__ + "img/arrow-up.9568c9fb.svg";